export const JOURNEY = [
  {
    id: "cultivation",
    num: "01",
    nameEn: "Cultivation",
    nameRu: "Выращивание",
    image: "/images/quality/cultivation.png",
    descEn:
      "Grown at 3,100m in the Andes, where altitude and climate produce stronger stems and richer colour.",
    descRu:
      "Выращивание на высоте 3 100 м в Андах, где климат формирует крепкие стебли и насыщенный цвет.",
  },
  {
    id: "selection",
    num: "02",
    nameEn: "Selection",
    nameRu: "Отбор",
    image: "/images/quality/selection.png",
    descEn:
      "Each stem is hand-selected at the perfect stage for opening, uniformity and vase life.",
    descRu:
      "Каждый стебель отбирается вручную на оптимальной стадии раскрытия, однородности и стойкости.",
  },
  {
    id: "postharvest",
    num: "03",
    nameEn: "Post-harvest",
    nameRu: "После сбора",
    image: "/images/quality/post-harvest.png",
    descEn:
      "Rapid hydration and cold-chain care lock in freshness from the moment of cutting.",
    descRu:
      "Быстрое насыщение влагой и холодовая цепь сохраняют свежесть с момента срезки.",
  },
  {
    id: "packaging",
    num: "04",
    nameEn: "Packaging",
    nameRu: "Упаковка",
    image: "/images/quality/packaging.png",
    descEn:
      "Protective, market-specific packaging safeguards every bloom in transit.",
    descRu:
      "Защитная упаковка с учётом рынка назначения бережёт каждый бутон во время перевозки.",
  },
  {
    id: "delivery",
    num: "05",
    nameEn: "Global delivery",
    nameRu: "Мировая доставка",
    image: "/images/quality/global-delivery.png",
    descEn:
      "Coordinated logistics deliver fresh flowers to five continents with reliable consistency.",
    descRu:
      "Скоординированная логистика обеспечивает стабильную доставку свежих цветов на пять континентов.",
  },
];